module.exports = __webpack_public_path__ + "img/1F55C.eda13369.svg";